<div class="flex flex-col md:flex-row min-h-screen bg-white">
  <!-- Sidebar para desktop -->
  <app-sidebar [circleNumber]="3" (backClick)="goBack()" class="bg-teu-purple hidden sm:block relative w-full md:w-[197px] h-[120px] md:h-auto flex-shrink-0 overflow-hidden"></app-sidebar>
  
  <!-- Header para móvil -->
  <app-header [circleNumber]="3" (backClick)="goBack()"></app-header>

  <!-- Main Content -->
  <div class="flex-1 flex flex-col">
    <app-subheader [circleNumber]="2" class="pt-[60px] md:pt-0"></app-subheader>

    <!-- Contenedor principal (más padding inferior en mobile + safe area) -->
    <!-- Form Content -->
    <div
      class="w-full xl:max-w-[1240px] 2xl:max-w-[1300px] mx-auto xl:mx-0 px-4 sm:px-6 md:px-8 xl:px-7 pb-28 md:pb-16 xl:pb-10"
      style="padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 88px);"
    >
      <h1 class="teu-title text-2xl md:text-[32px] mb-2 md:mb-4 text-left">
        Uso de mi préstamo
      </h1>
      <p class="teu-subtitle text-lg md:text-xl mb-8 md:mb-12 text-left">
        Completa la información sobre el uso de tu préstamo
      </p>
      <!-- Grid 3 columnas en desktop -->
      <form [formGroup]="loanUseForm" class="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-8">
        <!-- Col 1: ¿Para qué utilizarás tu préstamo? -->
        <div class="flex flex-col">
          <label class="block font-inter text-sm font-normal leading-[140%] text-black mb-2">
            ¿Para qué utilizarás tu préstamo?
          </label>
          <p-dropdown
            formControlName="purpose"
            [options]="purposeOptions"
            placeholder="Pagar un servicio"
            optionLabel="label"
            optionValue="value"
            class="w-full md:max-w-[300px]"
            [class.p-invalid]="isFieldInvalid('purpose')"
          ></p-dropdown>
          <small class="p-error" *ngIf="isFieldInvalid('purpose')">
            {{ getFieldError('purpose') }}
          </small>
        </div>
        <!-- Col 2: ¿Qué tipo de gasto? -->
        <div class="flex flex-col">
          <label class="block font-inter text-sm font-normal leading-[140%] text-black mb-2">
            ¿Qué tipo de gasto?
          </label>
          <p-dropdown
            formControlName="expenseType"
            [options]="expenseTypeOptions"
            placeholder="¿Qué tipo de gasto?"
            optionLabel="label"
            optionValue="value"
            class="w-full md:max-w-[300px]"
            [class.p-invalid]="isFieldInvalid('expenseType')"
          ></p-dropdown>
          <small class="p-error" *ngIf="isFieldInvalid('expenseType')">
            {{ getFieldError('expenseType') }}
          </small>
        </div>
        <!-- Col 3: ¿Desde donde estás realizando tu solicitud? -->
        <div class="flex flex-col md:col-span-1">
          <label class="block font-inter text-sm font-normal leading-[140%] text-black mb-2">
            ¿Desde donde estás realizando tu solicitud?
          </label>
          <p-dropdown
            formControlName="location"
            [options]="locationOptions"
            optionLabel="label"
            placeholder="¿Desde donde estás realiz..."
            [styleClass]="'w-full md:max-w-[300px]'"
            [class.p-invalid]="isFieldInvalid('location')"
          ></p-dropdown>
          <small class="p-error" *ngIf="isFieldInvalid('location')">
            {{ getFieldError('location') }}
          </small>
        </div>
        <!-- Segunda fila, Col 1: campo porcentaje (input corto) -->
        <div class="flex flex-col md:col-span-1">
          <label class="block font-inter text-sm font-normal leading-[140%] text-black mb-2">
            ¿Qué porcentaje de tu ingreso lo tienes comprometido en pagos de otras deudas?
          </label>
          <p-inputNumber
            formControlName="debtPercentage"
            [min]="0"
            [max]="100"
            [minFractionDigits]="0"
            [maxFractionDigits]="2"
            [useGrouping]="false"
            suffix=" %"
            [inputStyleClass]="'w-full md:max-w-[300px]'"
            placeholder="0 %"
            [class.p-invalid]="isFieldInvalid('debtPercentage')"
          ></p-inputNumber>
          <small class="p-error" *ngIf="isFieldInvalid('debtPercentage')">
            {{ getFieldError('debtPercentage') }}
          </small>
        </div>
        <!-- Botón Confirmar en la primera columna, alineado a la izquierda y más abajo -->
        <div class="md:col-span-1 md:col-start-1 md:row-start-3 md:mt-28 lg:mt-36 xl:mt-44">
          <button
            type="button"
            class="btn-primary w-full md:w-[300px] h-[46px]"
            [class.opacity-50]="loanUseForm.invalid"
            [disabled]="loanUseForm.invalid"
            (click)="onSubmit()"
          >
            Confirmar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
